import { PricingTierId } from '@business/entities/order';
import { CategoryResponse, CategoryId } from '../category';
import { PricingTierResponse } from '../order';
import { ServiceClassResponse } from './../project/ServiceClassResponse';
import { ProjectServiceId } from '../project';
import { VeryCompactOrgResponse } from '../organization';

export type CommissionId = string;

export interface CommissionResponse {
  id: CommissionId;
  value: number;
  label?: string;
  tiers: PricingTierResponse[];
  tierIds: PricingTierId[];
  categories: CategoryResponse[];
  classes: ServiceClassResponse[];
  services: ProjectServiceId[];
  timematerial: ProjectServiceId[];
  projects: string[];
  boards: string[];
  invoiceType: CommissionInvoiceType;
  settings: CommissionRowSettingsResponse;
}

export interface CommissionRowSettingsResponse {
  excludeOrgs: VeryCompactOrgResponse[];
  includeOrgs: VeryCompactOrgResponse[];
  excludeCategories: CategoryId[];
  includeCategories: CategoryId[];
  discountPercentage: string;
  customFields: Record<string, string>;
}

export interface CommissionRequest {
  items: Partial<CommissionResponse>[];
}

export enum CommissionPeriod {
  weekly = 'weekly',
  biweekly = 'biweekly',
  bimonthly = 'bimonthly',
  monthly = 'monthly',
}

export enum CommissionInvoiceType {
  all = 'all',
  recurring = 'recurring',
  nonRecurring = 'nonRecurring',
}
